import { useTranslation } from 'next-i18next';
import React, { } from 'react';
import TituloSeccion from '@/components/elements/TituloSeccion';
import { ImportarLibrosResponse } from '@/objects/Exporter';
import Texto from '@/components/elements/Texto';

interface Props {
    importarLibrosResumen: ImportarLibrosResponse;
}

function ExporterResumen({ importarLibrosResumen }: Props) {
    const { t } = useTranslation();

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TituloSeccion texto={t("menu:secciones.importar_exportar.resumen")} />
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <Texto>{t("menu:secciones.importar_exportar.insertados")} {importarLibrosResumen.insertados}</Texto>
                <Texto>{t("menu:secciones.importar_exportar.omitidos")} {importarLibrosResumen.omitidos}</Texto>
                <Texto>{t("menu:secciones.importar_exportar.razones_omision")}</Texto>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', paddingLeft: "20px" }}>
                    {importarLibrosResumen.lista_omitidos.map((libro, index) => (
                        <Texto key={index}>- {libro}</Texto>
                    ))}
                </div>
                <Texto>{t("menu:secciones.importar_exportar.errores")} {importarLibrosResumen.errores}</Texto>
                <Texto>{t("menu:secciones.importar_exportar.detalles")}</Texto>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', paddingLeft: "20px" }}>
                    {importarLibrosResumen.detalle_errores.map((error, index) => (
                        <Texto key={index}>- {error}</Texto>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ExporterResumen;